import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';
import {
  DomainEventUpdateItemDetailed,
  matterCmsUpdatesApiClient,
} from '@/services/api/matterCmsUpdatesService';

import { SyncUpdates } from '../filevine-sync';
import { MatterUpdates } from '../matter-changes/MatterUpdates';

const UpdatesView: React.FC = () => {
  const { matterId } = useMatter();

  const { data: updates } = matterCmsUpdatesApiClient.useCmsUpdatesListQuery({
    matterId,
  });

  if (!updates || !Array.isArray(updates)) {
    return null;
  }

  return (
    <div className="flex flex-col h-full">
      <UpdatesContent updates={updates as DomainEventUpdateItemDetailed[]} />
    </div>
  );
};

const UpdatesContent = ({
  updates,
}: {
  updates: DomainEventUpdateItemDetailed[];
}) => {
  const { matterId } = useMatter();
  const navigate = useNavigate();

  const handleAltClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    if (e.altKey) {
      navigate(`/matters/${matterId}/cms-sync`);
    }
  };

  return (
    <div className="flex flex-col gap-8 mx-auto w-full max-w-5xl">
      {/* Filevine Sync Updates Section */}
      <SyncUpdates />

      {/* Divider */}
      <div className="border-t border-gray-200" />

      {/* Matter Updates Section */}
      <div className="flex flex-col gap-4">
        <span
          className="text-2xl font-semibold"
          role="button"
          tabIndex={0}
          onClick={handleAltClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleAltClick(e);
            }
          }}
        >
          Matter Updates
        </span>
        <MatterUpdates updates={updates} />
      </div>
    </div>
  );
};

export default UpdatesView;
